<template>
	<nk-wrapper v-if="user" spacing="md">
		<nk-form
			:success="success"
			:error="error"
			success-message="Das Passwort wurde erfolgreich geändert"
			success-description="Sie können sich nun mit Ihrem neuen Passwort anmelden"
			:error-message="errorMessage"
			:error-description="
				errorDescription
					? `Wir werden versuchen den Fehler schnellstmöglich zu
				beheben. Bitte wenden Sie sich in dringenden Fällen direkt
				<a href='mailto:${genericMail}'>per E-Mail</a>
				an uns.`
					: null
			"
			name="ratsinfopasswortaendern"
			:schema="schema"
			@submit="processForm"
		/>

		<nk-wrapper spacing="md">
			<nk-text v-if="success">
				<nk-button @click.prevent="resetForm">Zurück zum Formular</nk-button>
			</nk-text>
		</nk-wrapper>
	</nk-wrapper>
</template>

<script>
export default {
	name: 'NkTemplateRatsinfosystemPasswortAendern',

	data() {
		const config = useRuntimeConfig();
		return {
			form: null,
			error: false,
			success: false,
			errorMessage: null,
			errorDescription: false,
			genericMail:
				config.public.NUXT_PUBLIC_FORM_RECEIVER_KONTAKT_GEMEINDE ||
				'info@webcontact.de',
			schema: [
				{
					component: 'h2',
					class: 'text-xl my-4',
					children: 'Passwort ändern',
					id: 'headline-1',
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-1-1',
					children: [
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-1-1',
							children: [
								{
									type: 'password',
									label: 'Passwort',
									placeholder: '••••••••',
									name: 'passwort',
									validation: 'required|min:8',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-1-2',
							children: [
								{
									type: 'password',
									label: 'Neues Passwort',
									placeholder: '••••••••',
									name: 'passwortNeu',
									validation: 'required|min:8',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-1-3',
							children: [
								{
									type: 'password',
									label: 'Neues Passwort wiederholen',
									placeholder: '••••••••',
									name: 'passwortNeuWiederholung',
									validation: 'required|min:8',
								},
							],
						},
					],
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-6',
					children: [
						{
							component: 'div',
							class: 'w-auto  p-2',
							id: 'col-6-1',
							children: [
								{
									type: 'submit',
									name: 'Passwort ändern',
								},
							],
						},
					],
				},
			],
		};
	},

	computed: {
		user() {
			return this.$store.state.nuxtKommunen.ratsinfoauth.user;
		},
	},

	methods: {
		resetForm() {
			this.form = null;
			this.error = false;
			this.success = false;
			this.errorMessage = null;
			this.errorDescription = false;
		},

		processForm(form) {
			this.form = form;
			this.changePassword();
		},

		async changePassword() {
			// User noch eingeloggt?
			if (!this.user) return;

			const self = this;
			document.querySelector('[type="submit"]').disabled = true;

			try {
				// Stimmt das alte Passwort?
				const chkLogin = await this.$store.dispatch(
					'nuxtKommunen/ratsinfoauth/login',
					{
						email: self.user.email,
						passwort: self.form.passwort,
					},
				);

				if (!chkLogin) {
					this.errorMessage = 'Ihr altes Passwort ist nicht korrekt!';
					throw this.errorMessage;
				}

				// Ist das neue Passwort gleich dem alten Passwort?
				if (self.form.passwort === self.form.passwortNeu) {
					this.errorMessage =
						'Das neue Passwort darf nicht identisch mit dem alten Passwort sein.';
					throw this.errorMessage;
				}

				// Ist das neue Passwort gleich dem alten Passwort?
				if (self.form.passwortNeu.includes(self.form.passwort)) {
					this.errorMessage =
						'Das neue Passwort darf das alte Passwort nicht enthalten.';
					throw this.errorMessage;
				}

				// Ist das neue Passwort gleich dem alten Passwort?
				if (self.form.passwortNeu !== self.form.passwortNeuWiederholung) {
					this.errorMessage =
						'Das neue Passwort und die Wiederholung stimmen nicht überein.';
					throw this.errorMessage;
				}

				// Passwort in die Datenbank schreiben
				try {
					await this.$axios({
						method: 'PATCH',
						url: `/api/cms/raete/${this.user.id}`,
						headers: {
							'Content-Type': 'application/json',
						},
						data: {
							passwort: self.form.passwortNeu,
						},
					});

					await this.$store.dispatch('nuxtKommunen/ratsinfoauth/login', {
						email: self.user.email,
						passwort: self.form.passwortNeu,
					});
				} catch (error) {
					this.errorMessage =
						'Leider ist ein Fehler beim Ändern des Passworts aufgetreten';
					this.errorDescription = true;
					throw this.errorMessage;
				}

				self.success = true;
				self.error = false;

				// Error
			} catch (error) {
				this.error = true;
				// Always
			} finally {
				document.querySelector('[type="submit"]').disabled = false;
			}
		},
	},
};
</script>
